// src/components/Navbar.jsx

import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../config/AuthProvider';
import { FaCalculator, FaChartBar, FaCalendarAlt, FaSignOutAlt } from 'react-icons/fa';
import '../css/Navbar.css'; // Provjerite putanju prema vašem CSS fajlu

function Navbar() {
  const { currentUser, logout } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      await logout();
      // Opcionalno: preusmjerite korisnika nakon odjave
    } catch (error) {
      console.error('Greška pri odjavi:', error);
      alert('Došlo je do greške prilikom odjave. Pokušajte ponovno.');
    }
  };

  return (
    <nav className="navbar">
      <ul>
        <li>
          <NavLink to="/" end>
            <FaCalculator className="nav-icon" />
            <span>Obračun</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/metrike">
            <FaChartBar className="nav-icon" />
            <span>Metrike</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/raspored">
            <FaCalendarAlt className="nav-icon" />
            <span>Raspored</span>
          </NavLink>
        </li>
        {currentUser && (
          <li className="logout">
            <button onClick={handleLogout}>
              <FaSignOutAlt className="nav-icon" />
              <span>Odjava</span>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;